import React from "react";
import Box from "react-raster";
import { Heading, Paper } from "src/components";
import { Card } from "src/views/card";
import { theme } from "src/config";
import { Question } from "src/models";
import { Colors, QuestionPosition } from "src/types";

export const CardSection = () => {
  const dummyQuestion = Question.create({
    position:     QuestionPosition.Board,
    room_id:      1,
    title:        "Hi",
    desc:         "Can I get a bagel?",
    date:         new Date(),
    number:       5,
    workspace_id: 1,
    answered:     false,
    processed:    false,
    decided:      false,
  });

  return (
    <Box display='grid' flexDirection='column'>
      <Heading weight="normal" type="h3" color="black" text="Cards">Cards</Heading>
      <Box><hr /></Box> 
      <Box
        marginTop     = '2rem'
        display       = 'flex'
        flexDirection = 'row'
        gridRowGap    = {theme.layout.gutter}
        gridColumnGap = {theme.layout.gutter}>
        <Card data={dummyQuestion} />
        <Card data ={dummyQuestion} />
      </Box>
    </Box>
  );
};
